import { Icon } from '@winnin/winnin_ui.components.icon'

import { ICON_ZAI_INITIAL_PROPS } from './constants'
import type { IconZaiAnimationProps } from './types'

import './styles.scss'

const IconZaiAnimation = ({
  color = ICON_ZAI_INITIAL_PROPS.color,
  size = ICON_ZAI_INITIAL_PROPS.size,
  isAnimating,
}: IconZaiAnimationProps) => {
  return (
    <div className={`IconZaiAnimation ${isAnimating ? 'animate' : ''}`}>
      <Icon icon="sparkle" height={size.height} width={size.width} fill={color} />
    </div>
  )
}

export default IconZaiAnimation
